import { z } from 'zod';
import { apiClient } from './client';
import { dailyAnswer, dailyArchive, dailySnapshot, dailyToday } from './daily-contract';

export const dailyApi = {
  today: async () => dailyToday.parse(await apiClient.daily.getToday()),
  snapshot: async (category?: string, date?: string) => {
    const state = dailySnapshot.parse(await apiClient.daily.getSnapshot({ category, date }));
    if ((category && state.category && state.category !== category) || (date && state.date !== date))
      throw new Error('Daily snapshot mismatch');
    return { ...state, category: state.category || category || '' };
  },
  start: async (category: string, date: string) => {
    const state = dailySnapshot.parse(await apiClient.daily.start({ category, date }));
    if (state.category !== category || state.date !== date) throw new Error('Daily start mismatch');
    return state;
  },
  answer: async (category: string, date: string, text: string, skip: boolean, actionId: string) =>
    dailyAnswer.parse(
      await apiClient.daily.answer(
        { category, date, text: skip ? undefined : text, skip, actionId },
        { idempotencyKey: actionId },
      ),
    ),
  archive: async () => dailyArchive.parse(await apiClient.daily.getArchive()).data,
  unlock: async (category: string, date: string, actionId: string) =>
    z
      .object({
        success: z.boolean(),
        coinsSpent: z.number(),
        accessSource: z.enum(['free', 'premium', 'purchased']),
        permanent: z.boolean(),
        yearMonth: z.string(),
      })
      .parse(await apiClient.daily.unlockArchive({ category, date, actionId }, { idempotencyKey: actionId })),
};
